import Arrow from 'Elements/Button/Arrow/Arrow';
import styled, { css } from 'styled-components';

export const Card = styled.div<{ $backgroundColourGrey?: boolean }>`
    ${({ theme, $backgroundColourGrey }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1.5rem 0;
        position: relative;
        border-radius: 0.5rem;
        background: ${$backgroundColourGrey
            ? `${theme.colors.secondary.tints[1].hex}`
            : `${theme.colors.primaryContrast.hex}`};
        height: 100%;
        margin-bottom: 1.8rem;
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-size: 1.5rem;
        color: ${theme.colors.secondaryContrast.hex};
        margin: 0 0 1.5rem 0;
        padding: 0 1rem;
        text-align: center;
    `}
`;

export const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 11rem;
`;

export const Text = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.secondaryContrast.hex};
        padding: 0 4rem 0.5rem 4rem;
        margin-top: 1.25rem;
        margin-bottom: 0;
        text-align: center;
    `}
`;

export const ArrowButton = styled(Arrow)`
    max-width: 80%;
    position: absolute;
    top: 92.5%;
    white-space: normal;
    text-align: center;
`;
